/* eslint-disable prefer-const */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import styles from "./GohonzonInventory.styles";
import CardWithFooter from "./CardWithFooter/CardWithFooter";
import Typography from "../../../components/common/new/Typography/Typography";
import Button from "../../../components/common/Button";
import Table from "../../../components/common/new/Table/Table";
import GohonzonInventoryModal from "./components/GohonzonInventoryModal";
import AddGohonzon from "../../../assets/svg/AddGohonzon.svg";
import Gohonzon from "../../../services/api/gohonzon";
import { getGohonzonType } from "../../../utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import {
  MASTER_INVENTORY_COL,
  RECENT_GOHONZON_COL,
} from "../../../contants/table/gohonzonSearch";
import { ROUTES } from "../../../utils/constants";

function GohonzonInventory() {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [masterData, setMasterData] = useState([]);
  const [gohonzonData, setGohonzonData] = useState([]);

  const fetchData = async () => {
    try {
      const result = await Gohonzon.getGohonzonInventoryDetails({});
      setSearchData(result.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMasterData = async () => {
    try {
      let data = {
        gohonzonType: "",
        updateType: "ADDITION_HQ",
      };
      const result = await Gohonzon.getGohonzonMasterInventory({
        data,
      });
      setMasterData(result.data.content);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchGohonzonData = async () => {
    try {
      let data = {
        gohonzonType: "",
        updateType: "",
      };
      const result = await Gohonzon.getGohonzonMasterInventory({
        data,
      });
      setGohonzonData(result.data.content);
    } catch (err) {
      console.log(err);
    }
  };

  const getAlloted = () => (
    <Box style={styles.listContainer}>
      {searchData.map((item, index) => (
        <Box key={index} style={styles.item}>
          <Typography variant="mini" style={{ color: "#183053" }}>
            {getGohonzonType(item.gohonzonType)}
          </Typography>
          <Typography weight={500} variant="mini" style={{ color: "#183053" }}>
            {item.totalAlloted}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const getReturned = () => (
    <Box style={styles.listContainer}>
      {searchData.map((item, index) => (
        <Box key={index} style={styles.item}>
          <Typography variant="mini" style={{ color: "#183053" }}>
            {getGohonzonType(item.gohonzonType)}
          </Typography>
          <Typography weight={500} variant="mini" style={{ color: "#183053" }}>
            {item.totalReturned}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const getAvailable = () => (
    <Box style={styles.listContainer}>
      {searchData.map((item, index) => (
        <Box key={index} style={styles.item}>
          <Typography variant="mini" style={{ color: "#183053" }}>
            {getGohonzonType(item.gohonzonType)}
          </Typography>
          <Typography weight={500} variant="mini" style={{ color: "#183053" }}>
            {item.totalAvailable}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen((prev) => !prev);
  };

  const getRows = () =>
    gohonzonData.slice(0, 5).map((gohonzon) => (
      <TableRow>
        <TableCell>
          {gohonzon.dateOfReceivingGohonzon !== null
            ? moment(gohonzon.dateOfReceivingGohonzon).format("DD/MM/YYYY")
            : "NA"}
        </TableCell>
        <TableCell>{getGohonzonType(gohonzon.gohonzonType)}</TableCell>
        <TableCell>{gohonzon.updateType.replace(/_/g, " ") || "NA"}</TableCell>
        <TableCell>
          {gohonzon.handoverMemberId ? (
            <span>
              {gohonzon.handoverTo} (ID:{gohonzon.handoverMemberId})
            </span>
          ) : (
            "NA"
          )}
        </TableCell>
        <TableCell>
          {" "}
          {[
            gohonzon?.areaName,
            gohonzon?.zoneName,
            gohonzon?.regionName,
            gohonzon?.chapterName,
            gohonzon?.districtName,
            gohonzon?.blockName,
          ]
            .filter(Boolean)
            .join("/ ") || "NA"}{" "}
        </TableCell>
      </TableRow>
    ));

  const getMasterRows = () =>
    masterData.slice(0, 5).map((gohonzon) => (
      <TableRow>
        <TableCell>
          {gohonzon.dateOfReceivingGohonzon !== null
            ? moment(gohonzon.dateOfReceivingGohonzon).format(" DD/MM/YYYY")
            : "NA"}
        </TableCell>
        <TableCell>{getGohonzonType(gohonzon.gohonzonType)}</TableCell>
        <TableCell>{gohonzon.quantity || "NA"} </TableCell>
      </TableRow>
    ));

  const refreshList = () => {
    fetchData();
    fetchMasterData();
    fetchGohonzonData();
  };

  useEffect(() => {
    fetchData();
    fetchMasterData();
    fetchGohonzonData();
  }, []);
  return (
    <Box style={styles.mainContainer}>
      <Box>
        <Box style={styles.main}>
          <Box style={styles.cardContainer}>
            <CardWithFooter
              title="TOTAL GOHONZON ALLOTED"
              minHeight={100}
              hideFooter
            >
              {getAlloted(searchData)}
            </CardWithFooter>
            <CardWithFooter
              title="TOTAL GOHONZON RETURNED"
              minHeight={100}
              hideFooter
            >
              {getReturned(searchData)}
            </CardWithFooter>
            <CardWithFooter
              title="TOTAL GOHONZON AVAILABLE"
              minHeight={100}
              hideFooter
            >
              {getAvailable(searchData)}
            </CardWithFooter>
          </Box>
          <Box style={styles.cardContainer}>
            <CardWithFooter
              mainContainerStyle={styles.appointment}
              title="RECENT GOHONZON ENTRIES"
              minHeight={201}
              routeTo={`/${ROUTES.HANDOVER_INVENTORY.path}`}
            >
              <Table
                columns={RECENT_GOHONZON_COL}
                columnCellStyle={{ textAlign: "left" }}
                headCellStyle={{ fontSize: 12 }}
                scrollable
                rows={getRows(gohonzonData)}
                tableBodyTheme="#F6F6F6"
                tableHeadCellStyle={{
                  ...styles.tableHeadCells,
                  // textAlign: "left",
                }}
              />
            </CardWithFooter>
          </Box>
        </Box>
        <Box
          style={{
            ...styles.main,
            display: "flex",
            gap: "10px",
          }}
        >
          <CardWithFooter
            minHeight={201}
            title="MASTER INVENTORY UPDATES"
            routeTo={`/${ROUTES.MASTER_INVENTORY.path}`}
          >
            <Table
              columns={MASTER_INVENTORY_COL}
              columnCellStyle={{ textAlign: "left" }}
              headCellStyle={{ fontSize: 12 }}
              scrollable
              rows={getMasterRows(masterData)}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...styles.tableHeadCells,
                // textAlign: "left",
              }}
            />
          </CardWithFooter>
          <Box>
            <CardWithFooter minHeight={158} hideFooter>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                height="100%"
                gap="30px"
              >
                <Box display="flex" justifyContent="space-between">
                  <Box>
                    <img
                      src={AddGohonzon}
                      alt="Add Gohonzon"
                      style={{ width: "60px" }}
                    />
                  </Box>
                  <Box>
                    <Button
                      variant="contained"
                      style={{
                        ...styles.actionBtn,
                        marginBottom: "10px",
                        width: "140px",
                      }}
                      label="ADD GOHONZON"
                      onClick={handleModalOpen}
                    />
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="flex-end"
                  minHeight={40}
                  flexDirection="row"
                >
                  <Typography variant="mini" weight={500} align="center">
                    Add New Gohonzon Received from the Headquarters
                  </Typography>
                </Box>
              </Box>
            </CardWithFooter>
          </Box>
        </Box>
      </Box>
      <GohonzonInventoryModal
        open={modalOpen}
        onClose={handleModalClose}
        toast={toast}
        refreshList={refreshList}
      />
    </Box>
  );
}

export default GohonzonInventory;
